/**
 * Terms of Use Header
 * Title block and intro paragraphs — exact legal text from prototype.
 */

export const TermsOfUseHeader = () => (
  <>
    <h1 style={{ paddingTop: '3pt', textIndent: '0pt', textAlign: 'center' }}>
      THE BQUEST, LLC <span className="p">("bQuest")</span>
    </h1>
    <p style={{ textIndent: '0pt', textAlign: 'left' }}><br /></p>
    <h1 style={{ textIndent: '0pt', textAlign: 'center' }}>TERMS OF SERVICE</h1>
    <p style={{ textIndent: '0pt', textAlign: 'left' }}><br /></p>
    <p style={{ paddingLeft: '5pt', textIndent: '0pt', textAlign: 'justify' }}>
      Please read the following Terms of Service carefully. If you do not agree
      with these terms governing your relationship with bQuest, you should not use
      the bQuest applications, website, platform, or other software or technology
      products.
    </p>
    <p className="s1" style={{ paddingTop: '13pt', textIndent: '0pt', textAlign: 'center' }}>
      Last updated December 1, 2024
    </p>
    <p style={{ textIndent: '0pt', textAlign: 'left' }}><br /></p>
    <p style={{ paddingLeft: '5pt', textIndent: '0pt', textAlign: 'justify' }}>
      <a href="http://www.thebquest.com/" className="a" target="_blank">
        This Agreement constitutes a legally binding agreement (the "Agreement")
        between you and BQuest, LLC ("BQuest," "we," "us" or "our"), governing
        your use of the applications, websites, and/or other software or
        technology products available through https://
      </a>
      www.thebquest.com/, including any and all subdomains or subdirectories
      thereof (the "BQUEST URL"), and available through mobile, desktop, or device
      applications ("Apps") and bQuest-controlled social media pages (including
      Facebook, Instagram, Spotify, YouTube, LinkedIn, and X under any and all
      developer accounts connected to bQuest or the bQuest URL accessed through
      the iOS App Store, the Google Play Store, or any other platform for the
      distribution of software applications (collectively, the "bQuest Platform").
    </p>
    <p style={{ textIndent: '0pt', textAlign: 'left' }}><br /></p>
    <p style={{ paddingLeft: '5pt', textIndent: '0pt', textAlign: 'justify' }}>
      PLEASE BE ADVISED: THIS AGREEMENT CONTAINS PROVISIONS THAT GOVERN HOW CLAIMS
      BETWEEN YOU AND BQUEST CAN BE BROUGHT (SEE SECTION 18 BELOW). THESE
      PROVISIONS WILL, WITH LIMITED EXCEPTION, REQUIRE YOU TO SUBMIT CLAIMS YOU
      HAVE AGAINST BQUEST TO BINDING AND FINAL ARBITRATION ON AN INDIVIDUAL BASIS,
      NOT AS A PLAINTIFF OR CLASS MEMBER IN ANY CLASS, GROUP OR REPRESENTATIVE
      ACTION OR PROCEEDING.
    </p>
    <p style={{ textIndent: '0pt', textAlign: 'left' }}><br /></p>
    <p style={{ paddingLeft: '5pt', textIndent: '0pt', textAlign: 'justify' }}>
      By entering into this Agreement, and/or by using or accessing the bQuest
      Platform, you expressly acknowledge that you are at least 18 years of age
      and that you understand this Agreement (including the dispute resolution and
      arbitration provisions in Section 18) and the Privacy Policy (the "Privacy
      Policy") available at <span className="s2">LINK</span> and accept all of
      their respective terms. The Privacy Policy is incorporated by reference into
      this Agreement. IF YOU DO NOT AGREE TO BE BOUND BY THE TERMS AND CONDITIONS
      OF THIS AGREEMENT AND THE PRIVACY POLICY, YOU MAY NOT USE OR ACCESS THE
      BQUEST PLATFORM.
    </p>
    <p style={{ textIndent: '0pt', textAlign: 'left' }}><br /></p>
  </>
);
